import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

export default function SlaMetricsWidget({ complianceRate = 0 }) {
  const rate = Math.min(Math.max(Number(complianceRate) || 0, 0), 100);
  const data = [
    { name: 'Met SLA', value: rate,       color: '#3B5BDB' },
    { name: 'Violated', value: 100 - rate, color: '#ef4444' },
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
      <div style={{ fontSize: 14, fontWeight: 600, color: '#2D3748', alignSelf: 'flex-start' }}>Ticket SLA Metrics</div>
      <div style={{ position: 'relative', width: 140, height: 140 }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              innerRadius={50}
              outerRadius={70}
              startAngle={90}
              endAngle={-270}
              dataKey="value"
              stroke="none"
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', textAlign: 'center' }}>
          <div style={{ fontSize: 24, fontWeight: 700, color: '#1A202C' }}>{rate}%</div>
          <div style={{ fontSize: 10, color: '#718096' }}>SLA Met</div>
        </div>
      </div>
      <div style={{ display: 'flex', gap: 16, fontSize: 12 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}><div style={{ width: 8, height: 8, borderRadius: '50%', background: '#3B5BDB' }}/> Met SLA</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}><div style={{ width: 8, height: 8, borderRadius: '50%', background: '#ef4444' }}/> Violated</div>
      </div>
    </div>
  );
}
